function t(t, o, r, a) {
  void 0 === r && (r = .1), void 0 === a && (a = .001);
  var e = (o - t) * r;
  return Math.abs(e) < a && (e = o - t), e;
}

export default t;
export { t as lerp };